module.exports = __webpack_public_path__ + "img/42_9.6b2b28f4.png";